import { ToggleButtonProps } from './types'
import { forwardRef, useId } from 'react'

import classNames from 'classnames'
import styles from './ToggleButton.module.css'
import { preventDefault } from '../../utils'

const ToggleButton = forwardRef<HTMLInputElement, ToggleButtonProps>(function ToggleButton(
  {
    id: id_,
    children,
    value,
    name,
    onChange: onChange,
    onClick,
    className: externalStyles,
    type = 'radio',
    size = 'default',
    disabled_,
    disabled,
    fullWidth,
    ...props
  },
  ref
) {
  const className = classNames(styles.button, styles[`size-${size}`], externalStyles)

  const generatedId = useId()
  const id = id_ || name || generatedId
  const composedId = `${id}-${String(value)}`
  const isInputDisabled = disabled || disabled_

  return (
    <label
      htmlFor={composedId}
      className={classNames(
        {
          ['fullWidth']: fullWidth && fullWidth !== 'mobile-only',
          ['fullWidthOnMobile']: fullWidth && fullWidth === 'mobile-only',
        },
        className
      )}
    >
      <input
        {...props}
        ref={ref}
        id={composedId}
        aria-disabled={isInputDisabled}
        type={type}
        value={value}
        name={name}
        onClick={isInputDisabled ? preventDefault : onClick}
        onChange={isInputDisabled ? preventDefault : onChange}
        className={styles.hiddenInput}
        disabled={disabled_}
      />
      {children}
    </label>
  )
})

export default ToggleButton
